export const WSPDashboard = 'WSPDashboard';
export const FundingChart = `${WSPDashboard}/FundingChart`;
export const TrainingChart = `${WSPDashboard}/TrainingChart`;
export const OFOCodeChart = `${WSPDashboard}/OFOCodeChart`;
export const WorkforceProfileOFOCodeSummary = `${WSPDashboard}/WorkforceProfileOFOCodeSummary`;
export const WorkforceProfileOFOCodeSummarySearch = `${WorkforceProfileOFOCodeSummary}/Search`;